import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

export  const admin: Routes = [
  {
    path: 'payment',
    children: [
      {
        path: 'checkout',
        loadComponent: () =>
          import('./checkout/checkout.component').then((m) => m.CheckoutComponent),
      },
      {
        path: 'success',
        loadComponent: () =>
          import('./success/success.component').then((m) => m.SuccessComponent),
      },
      {
        path: 'cancel',
        loadComponent: () =>
          import('./cancel/cancel.component').then((m) => m.CancelComponent),
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(admin)],
  exports: [RouterModule],
})
export class PaymentRoutingModule {
  static routes = admin;
}
